module.exports = __webpack_public_path__ + "media/assets/logo/Logo_SemFundo_Agrosim_reduzido_not_found-4c8fc150c0e4a07da765ae7484f3e8a7.png";